<template>
  <svg :height="height" :width="width">
    <circle :cx="width / 2" :cy="height / 2" :r="r" :fill="color" />
  </svg>
</template>
<script>
import { HIGHLIGHT_COLOR } from '@/constants/style';
export default {
  name: 'CircleIcon',
  props: {
    width: {
      type: String,
      default: '13'
    },
    height: {
      type: String,
      default: '13'
    },
    color: {
      type: String,
      default: HIGHLIGHT_COLOR
    },
    r: {
      type: String,
      default: '6.5'
    }
  }
};
</script>

<style></style>
